
import { finalize } from 'rxjs/operators';
import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { FormGroup, FormControl, NgForm, AbstractControl, NgModel } from '@angular/forms';
import { stringify } from 'json-stringify-safe'
import { FileInfo, UploadEvent, RemoveEvent } from '@progress/kendo-angular-upload';
import { GridDataResult, DataStateChangeEvent, SelectionEvent } from '@progress/kendo-angular-grid';
import { IntlModule } from '@progress/kendo-angular-intl';

import { PrettyJsonModule } from 'angular2-prettyjson';
import { Subscription, Subject, Observable } from 'rxjs'
import { State } from '@progress/kendo-data-query';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime'

import { CustomersService, ExcelImportService, UserProfileService, RvService, AddDaysToDate, RIAHelper } from '../../../core';

import { AlertComponent, EnumAlertType } from '../../../common/component/alert/alert.component';

import { environment } from '../../../../environments/environment'
import { CalendarComponent } from '../../../common/component/calendar/calendar.component';
import { AuditAvl_AuditSchedule } from '../../../core/models/AuditAvl_AuditSchedule-model'
import { AuditAvl_Audit } from '../../../core/models/AuditAvl_Audit-model'
import { AuditAvl_AuditProperty } from '../../../core/models/AuditAvl_AuditProperty-model'
import { AuditStd_StandardAuditProperties, ConvertToAuditStd_StandardAuditProperties } from '../../../core/models/audit-std_standard-audit-properties';
import { ConfirmDialogComponent } from '../../../common/component/confirm-dialog/confirm-dialog.component';
import {
  FineUploaderBasic, CoreOptions, ChunkingOptions, CorsOptions, RequestOptions
  , CoreEvents, OnComplete, ChunkData, ParamNamesOptions
} from 'fine-uploader/lib/core';
import { AuditStdImport, ImportResults, Property, Errors, Error } from '../../../main/rate-audit/ra-create/utilities/auditstd-import-model';
import { ThemeService } from '@progress/kendo-angular-charts';

interface Notification { id: string, name: string, isDefault: boolean };


@Component({
  selector: 'app-rv-create',
  templateUrl: './rv-create.component.html',
  styleUrls: ['./rv-create.component.scss']
})
export class RvCreateComponent implements OnInit {
  @ViewChild(CalendarComponent, { static: true }) calendarController: CalendarComponent;
  @ViewChild(AlertComponent, { static: false }) alertController: AlertComponent;
  @ViewChild(ConfirmDialogComponent, { static: true }) confirmDialog:ConfirmDialogComponent
  @ViewChild('fileItem', { static: false }) fileItem: NgModel;

  subscriptions: Subscription[] = [];
  showModal:boolean=false;
  public view: GridDataResult;
  public viewProperty: GridDataResult;
  public time: number;
  notificationName: string = "";
  notificationSelection: string = "1";//"Failed Audit Template";
  _notificationTemplateList: Notification[] = [];
  set notificationTemplateList(data: Notification[]) {
    this._notificationTemplateList = data;
    if (data.length > 0) {
      this.notificationSelection = data[0].id;
      this.notificationName = data[0].name;
      let dfault = data.filter(q => q.isDefault ? true : false);
      if (dfault.length > 0) {
        this.notificationSelection = dfault[0].id;
        this.notificationName = dfault[0].name;
      }
    }
  }
  constructor(
    private rvService: RvService
    , private router: Router
    , private route: ActivatedRoute
    , private userProfileService:UserProfileService
    , private excelImportService: ExcelImportService
    , private customersService: CustomersService
  ) {
    const now = this.now().date;
    this.datePickerStartDate = AddDaysToDate(now, 1).toJsDate();
    this.datePickerEndDate = AddDaysToDate(now, 90).toJsDate();
    this.minStartRange = now.toJsDate();
    this.maxEndRange = AddDaysToDate(now, 330).toJsDate();
    this.updateDateRangeMinMax();
    this.auditDate = now.date.toJsDate();
    this.auditTime = now.date.addHours(7).toJsDate();
    this.onRunNowClick();
    this.earliestRunDate = this.now().date.toJsDate();
    this.latestRunDate = this.maxEndRange;
    this.domainStr = environment.baseWebApiUrl;

  }

  ngOnInit() {
    this.isBusy = true;
    let current =  this.router.routerState.snapshot.url;
    let crrnt = this.route.snapshot.url;
    this.rvService.GetNotificationTemplate().pipe(
      finalize(()=>{
        this.isBusy = false;
      })).
      subscribe(data => {
        this.notificationTemplateList = data.map(d => { return { id: d.NotificationTemplateID, name: d.Name, isDefault: d.isDefault }; });
      });

    if(current.endsWith('upload-and-create')) {
      this.typeOfAudit='upload';
      this.selectFileControl = this.fileItem ? this.fileItem.control : undefined;
      this.setupFineUploader();
      this.step1.showNext = false;
      this.isBusy = false;

if(false){
  this.selectedFileToUpload = "Audit This";
  this.uploadStatistics = {
    TotalPropertyCount: "33",
    CustomerID: "185",
    // PreviousAuditTitle: "",
    // PreviousAuditID: "",
    // MatchPropertyCount: "",
  }
  this.validationErrorMessages = [{Message:"top level error message"}];

  this.propertyValidationErrorMessages = [
    {name:"Beach Combing and Bingo",Error:[{Message:"Validation issue 1"},{Message:"Validation issue 2"}]},
    {name:"Dallas Downtown",Error:[{Message:"Validation issue 1"},{Message:"Validation issue 2"}]},
]
}

    }else if(current.endsWith('create')) {
      this.typeOfAudit='createFromRateAudit';
      this.isBusy = true;
      this.rvService.getRateAuditDataForImport(this.state).pipe(
        finalize(()=>{
          this.isBusy = false;
        }))
        .subscribe(data => {
          this.view = data;
          if (data.total == undefined || data.total == 0) { this.norecords = false; } else { this.norecords = true; }
          this.step1.showNext = true;
        });
      }

      this.AuditContactEmailAddress = this.userProfileService.data.Email;

  }

  public notificationTemplateID: any[];
  public Name;
  public auditDate: Date;
  public auditTime: Date;
  public radioRunAuditWhen = "RunNow";
  public NotificationTemplateName;
  public NotificationTemplateSelectionID;
  public radioNotificationPackage;
  public auditDateTime: any = null;
  public AuditAvlObj: AuditAvl_AuditSchedule = { AuditID: " ", AuditScheduleID: " ", Name: " ", ProcessAuditWhen: null, AuditNotificationName: "", AuditNotificationID: " ", SendNotifications:false, AuditContactEmailAddress:"" };
  public AuditAvl_Audit: AuditAvl_Audit = new AuditAvl_Audit();


  public SelectedCalendarDates: Array<{
    DateSelected: Date;
  }> = [];

  public runNowisEnabled: boolean = false;
  public state: State = {
    skip: 0,
    take: 10
  };
  public stateProperty: State = {
    skip: 0,
    take: 10
  };
  sorted: string = "";
  sortedProperty: string = "";
  norecords: boolean = true;
  auditPropertyID: any;
  datePickerStartDate: Date;
  initialEventDatePicker: Date;
  datePickerEndDate: Date;
  minStartRange: Date;
  maxStartRange: Date;
  minEndRange: Date;
  maxEndRange: Date;
  public auditID:string="";
  public RACFilters:string="";
  public SabrePCC:string="";
  public AmadeusRAC:string="";
  public ApolloRAC:string="";
  public GalileoRAC:string="";
  public SabreRAC:string="";
  public WorldspanRAC:string="";
  public AuditName:string="";
  public AuditAmadeus:boolean;
  public AuditApollo:boolean;
  public AuditGalileo:boolean;
  public AuditSabre:boolean;
  public AuditWorldspan:boolean;
  isBusy:boolean = false;
  isSelected:boolean=false;
  public AuditContactEmailAddress:string="";
  public typeOfAudit:string = "";

  RACTypeSelection: string = "Corporate";
  RACTypeOptions: string[] = ['Corporate', 'Negotiated', 'Consortia'];
  now: () => DateTime = () => DateTime.now;
  earliestRunDate: Date;
  latestRunDate: Date;
  buildNotification: boolean = false;
  myFiles: FileList = null;
  onFileSelected(event) {
    //clear out previous, if set
    this.onRemoveSelectedFile();

    if (!event.currentTarget || !event.currentTarget.files || event.currentTarget.files.length <= 0){
      return; //most likely the user canceled after a file had been selected
    }
    this.SetisBusy(true);
    this.myFiles = event.currentTarget.files;
    this.file = event.currentTarget.files[0];
    this.selectFileControl = this.fileItem.control;
    console.log(this.myFiles);
    var arr = Array.from(this.myFiles);
    this.uploader.addFiles(arr);
  }
  file: any;
  selectedFileToUpload = "";
  selectedFileOnServer = "";
  sessionGuid = "";
  uploadFilesize: string;
  initUploadStats: ImportResults = { TotalPropertyCount: "", CustomerID:""};
  uploadStatistics: ImportResults = this.initUploadStats;
  selectFileControl: AbstractControl = null;
  private domainStr: string;
  validationErrorMessages:{Message:string}[]=[];
  propertyValidationErrorMessages:{name:string,Error:Error[]}[]=[];


  onRemoveSelectedFile() {
    this.selectedFileToUpload = "";
    this.selectedFileOnServer = "";
    this.sessionGuid = "";
    this.uploadStatistics = this.initUploadStats;
    this.myFiles = null;
    this.validationErrorMessages = [];
    this.propertyValidationErrorMessages = [];
    this.step1.showNext = false;
    this.okayToExit = true;
  }

  SetisBusy(enable: boolean) {
    this.isBusy = enable;
  }
  async setUploadedData(filename: string, data: any, filesize) {
    this.resetUploadControls();
    var validationErrors:Errors = data.ImportStatus.Errors?(data.ImportStatus.Errors.Error.length?data.ImportStatus.Errors:{Error:[data.ImportStatus.Errors.Error]}):{Error:[]};
    this.selectedFileToUpload = filename;
    this.uploadStatistics = data.ImportResults;
    if(!data.property.length){
      data.property = [data.property];
    }
    let dis:AuditStdImport = data;
    this.propertyValidationErrorMessages = dis.property
      .filter( r => r.ImportStatus.Errors!=null)
      .map(p =>{
                  return {
                    name:p.PropertyName?p.PropertyName:p.PropertyAddress
                    , Error: p.ImportStatus.Errors.Error.length?p.ImportStatus.Errors.Error:[{Message:(p.ImportStatus.Errors.Error as unknown as Error).Message}]
                  };
        });

    if(validationErrors.Error.length>0 || this.propertyValidationErrorMessages.length>0 ){
      this.validationErrorMessages = validationErrors.Error;
      this.showUploadError("Validation Errors");
    }
    else{
      this.okayToExit = false;
      this.step1.showNext = true;
      data.property = data.property.length ? data.property : [data.property];
      this.updateScreen(data);
      this.AmadeusRAC = data.AmadeusNegotiatedRate;
      this.ApolloRAC = data.ApolloNegotiatedRate;
      this.GalileoRAC = data.GalileoNegotiatedRate;
      this.SabreRAC = data.SabreNegotiatedRate;
      this.WorldspanRAC = data.WorldspanNegotiatedRate;

      this.auditStd_StandardAuditProperties = this.ConvertImportTo(dis.property);
      this.viewProperty = this.rvService.BuildGridDataResult(this.auditStd_StandardAuditProperties, this.stateProperty);

    }
    this.okayToExit = false;
   // this.importedData = data;

//    if (filesize > 1024) {
//      var sizeStr = " KB";
//      filesize = filesize / 1024;
//      if (filesize > 1024) {
//        filesize = filesize / 1024;
//        sizeStr = " MB";
//      }
//      this.uploadFilesize = filesize.toFixed(2) + sizeStr;
//    }

  }
  ConvertImportTo(property:Property[] ):AuditStd_StandardAuditProperties[]{
    return property.map( p => ConvertToAuditStd_StandardAuditProperties(p));
  }
  checkGDSCredentials(){
    this.customersService.getCustomersGDSCredentials().subscribe((gdsCredentials)=>{
      // this.disableAuditAmadeus = (gdsCredentials && gdsCredentials.AmadeusActive) ? false : true;
      // this.disableAuditApollo = (gdsCredentials && gdsCredentials.ApolloActive) ? false : true;
      // this.disableAuditGalileo = (gdsCredentials && gdsCredentials.GalileoActive) ? false : true;
      // this.disableAuditSabre = (gdsCredentials && gdsCredentials.SabreActive) ? false : true;
      // this.disableAuditWorldspan = (gdsCredentials && gdsCredentials.WorldspanActive) ? false : true;
    })
  }

  setupFineUploader() {
    const cors: CorsOptions = { expected: true, sendCredentials: true };
    const paramNames: ParamNamesOptions = {/*partIndex: 'SEQ'*/ };
    const chunking: ChunkingOptions = { concurrent: { enabled: false }, enabled: true, mandatory: false, partSize: 2000000, paramNames: paramNames };
    const request: RequestOptions = {
      inputName: 'filename', /*method: 'GET', paramsInBody: false, */
      endpoint: this.domainStr + 'Upload/UploadFile'
    } //?filename={0}&append={1}&SEQ={2}&Last={3}
    const callbacks: CoreEvents = {
      onError: (id: number, name: string, errorReason: string, xhr: XMLHttpRequest) => {
        console.log('onError ' + id); this.resetUploadControls();
        if(errorReason.indexOf('invalid extension') > 0)
          this.showUploadError(errorReason)
        else if (errorReason != "No files to upload.")
          this.showUploadError("Error uploading file.")
      },
      onProgress: (id: number, name: string, uploadedBytes: number, totalBytes: number) => { console.log('onProgress ' + id); },
      onResume: (id: number, name: string, chunkData: any) => { console.log('onResume ' + id); },
      onUploadChunk: (id: number, name: string, chunkData: ChunkData) => { console.log('onUploadChunk ' + id); },
      onUploadChunkSuccess: (id: number, chunkData: ChunkData, responseJSON: any, xhr: XMLHttpRequest) => { console.log('onUploadChunkSuccess ' + id); },
      onStatusChange: (id: number, oldStatus: string, newStatus: string) => { console.log('onStatusChange ' + id); },
      onSubmit: (id: number, name: string) => { console.log('onSubmit ' + id); },
      onSubmitted: (id: number, name: string) => { console.log('onSubmitted ' + id); },
      onUpload: (id: number, name: string) => { console.log('onUpload ' + id); },
      onComplete: (id: number, name: string, responseJSON: any, xhr: XMLHttpRequest) => {
        console.log('onComplete ' + id);
        if(responseJSON.success){
        this.selectedFileOnServer = responseJSON.uniqueFilename;
        this.sessionGuid = responseJSON.sessionGuid;
        const s1 = this.excelImportService.importRateAvailabilityExcelFile(responseJSON.uniqueFilename)
          .subscribe(
            async (data) => {
              if (data.delayedFile) {
                this.excelImportService.importExcelRetryDelayedFile(data.delayedFile)
                  .subscribe(
                    async (data2) => {
                      console.log("data2");
                      if (data2.delayError) {
                        this.showUploadError("Error while downloading results.");
                      } else {
                        await this.setUploadedData(name, data2.properties, this.file.size)
                      }
                    },
                    (err) => {
                      console.log("err2");
                      console.log(err);
                      if(err.status == 401){
                        this.userProfileService.TakeUserToLogoutPage();
                      } else {
                        this.showUploadError("Error dowloading upload results.");
                      }
                    });
              }
              else {
                await this.setUploadedData(name, data.properties, this.file.size)
              }
            },
            (err) => { 
              console.log(err);
              if(err.status == 401){
                this.userProfileService.TakeUserToLogoutPage();
              }
              else{
                this.showUploadError("Error processing file after it was uploaded, verify file format.");
              }
            }
          );
          this.subscriptions.push(s1);
        }
        else
        {
          if(responseJSON.error != undefined && responseJSON.error.indexOf("file is corrupted") > 0){
            this.showUploadError(responseJSON.error);
          }
          else{
            this.showUploadError("Error uploading file");
          }
        }
      },
    };
    const options: CoreOptions = { autoUpload: true, debug: true, validation:{
      allowedExtensions: ['xls', 'xlsx']
    }, chunking: chunking, cors: cors, request: request, callbacks: callbacks };
    this.uploader = new FineUploaderBasic(options);

  }
  uploader: FineUploaderBasic;

  showUploadError(msg: string) {
    this.resetUploadControls();
    this.alertController.showAlertMessage(5000, msg, EnumAlertType.Error);
  }
  resetUploadControls() {
    this.SetisBusy(false);
    //this.showGds=false;
  }



  step1: any = {
    showNext: false,
    showPrev: false
  };
  step2: any = {
    showNext: false,
    showPrev: false
  };




  updateDateRangeMinMax() {
    this.maxStartRange = AddDaysToDate(new DateTime(this.datePickerEndDate), -1).toJsDate();
    this.minEndRange = AddDaysToDate(new DateTime(this.datePickerStartDate), 1).toJsDate();
  }

  okayToExit: boolean = true;

  canDeactivate(): Observable<boolean> | boolean {
    // Allow synchronous navigation (`true`) if no crisis or the crisis is unchanged
    ;
    if (this.okayToExit == true)
      return true;
    // Otherwise ask the user with the dialog service and return its
    // promise which resolves to true or false when the user decides
    let answerObservable = this.confirmDialog.confirm("Are you sure you wish to cancel editing this audit?"
      , "Any unsaved changes will be lost.", "Confirmation", true);
    return answerObservable;
  //return true;

  }
  onRunNowClick() {
    this.radioRunAuditWhen = "RunNow";
    this.runNowisEnabled = true;
  }

  onRunLaterClick() {
    this.radioRunAuditWhen = "RunLater";
    this.runNowisEnabled = false;
  }

  onDateChange(value: Date): void {
    this.auditDate = value;
  }

  onTimeChange(value: Date): void {
    this.auditTime = value;
  }
  onStepChanged(event) {
    console.log("step changed");
  }
  auditStd_StandardAuditProperties:AuditStd_StandardAuditProperties[]=[];
  onStep1Next(event) {
  if(this.typeOfAudit=='upload'){

  }else{
    event.okToProceed = false;
    this.okayToExit = false;
    if(this.isSelected==true){
      event.okToProceed = true;
      this.isBusy=true;
      this.rvService.ImportStandardAuditProperty(this.auditID, this.stateProperty).pipe(
        finalize(() => {this.isBusy=false;})).
        subscribe(data => {
            this.auditStd_StandardAuditProperties = data;
            this.viewProperty = this.rvService.BuildGridDataResult(this.auditStd_StandardAuditProperties, this.stateProperty);
          });
      this.rvService.getAuditStd_GetDefaultRACSettingForProcessRun(this.auditID).
        subscribe(data => {
          this.AmadeusRAC = this.AuditAmadeus? data.AmadeusRAC:"";
          this.ApolloRAC = this.AuditApollo?data.ApolloRAC:"";
          this.GalileoRAC = this.AuditGalileo?data.GalileoRAC:"";
          this.SabreRAC = this.AuditSabre?data.SabreRAC:"";
          this.WorldspanRAC = this.AuditWorldspan?data.WorldspanRAC:"";
        });
      }
      else{
        this.alertController.showAlertMessage(5000,"Please select an audit to import",EnumAlertType.Error);
      }
  }


  }
  selectedDates: DateTime[];
  jsDates: Date[];
  onStep2Next(event) {
    event.okToProceed = false;

    if (this.AmadeusRAC == "" && this.ApolloRAC == "" && this.GalileoRAC == "" && this.SabreRAC == ""
      && this.WorldspanRAC == "") {
      window.scrollTo(0, 0);
      this.confirmDialog.confirm("Please select at least one GDS Rate Access Code","","Validation Error");
    }

    else {
      if (this.RACTypeSelection == "Corporate") {
        this.AuditAvl_Audit.RateAccessType = "C";
      }
      else if (this.RACTypeSelection == "Negotiated") {
        this.AuditAvl_Audit.RateAccessType = "N";
      }
      else if (this.RACTypeSelection == "Consortia") {
        this.AuditAvl_Audit.RateAccessType = "X";
      }
      this.AuditAvl_Audit.AuditID = this.auditID;
      this.AuditAvl_Audit.Name = this.AuditName;
      this.AuditAvl_Audit.RACFilters = this.RACFilters;
      this.AuditAvl_Audit.PlacedOnQueue = this.now().toJsDate();
      this.AuditAvl_Audit.SabrePCC = this.SabrePCC;
      this.AuditAvl_Audit.AuditAmadeus = this.AuditAmadeus && (this.AmadeusRAC?(this.AmadeusRAC.trim()!=""):false);
      this.AuditAvl_Audit.AuditApollo = this.AuditApollo && (this.ApolloRAC?(this.ApolloRAC.trim()!=""):false);
      this.AuditAvl_Audit.AuditGalileo = this.AuditGalileo && (this.GalileoRAC?(this.GalileoRAC.trim()!=""):false);
      this.AuditAvl_Audit.AuditSabre = this.AuditSabre && (this.SabreRAC?(this.SabreRAC.trim()!=""):false);
      this.AuditAvl_Audit.AuditWorldspan = this.AuditWorldspan && (this.WorldspanRAC?(this.WorldspanRAC.trim()!=""):false);

      this.selectedDates = this.calendarController.GetCalendarSelectedDates();

      if (this.selectedDates.length == 0) {

        this.confirmDialog.confirm("Please select at least one date","","Validation Error");
        window.scrollTo(0, 0);

      }
      else {
        this.AuditAvl_Audit.Dateselected = this.selectedDates.map(date => RIAHelper.BuildWsDateFromDateTimeForRateAvail(date));

        this.AuditAvl_Audit.PropSelected=[];
        this.auditStd_StandardAuditProperties.forEach(element => {
          if (element.checked) {

            this.AuditAvl_Audit.PropSelected.push({

              AuditPropertyID: "00000000-0000-0000-0000-000000000000",//server creates it
              AuditID: this.auditID,
              Name: element.Name,
              Address: element.Address,
              City: element.City,
              StateProvince: element.StateProvince,
              PostalCode: element.PostalCode,
              CountryCode: element.CountryCode,
              ContactName: element.ContactName,
              ContactEMail: element.ContactEMail,
              AmadeusChainCode: element.AmadeusChainCode,
              AmadeusPropCode: element.AmadeusPropCode,
              AmadeusRateAccessCode: this.AmadeusRAC,
              ApolloChainCode: element.ApolloChainCode,
              ApolloPropCode: element.ApolloPropCode,
              ApolloRateAccessCode: this.ApolloRAC,
              GalileoChainCode: element.GalileoChainCode,
              GalileoPropCode: element.GalileoPropCode,
              GalileoRateAccessCode: this.GalileoRAC,
              SabreChainCode: element.SabreChainCode,
              SabrePropCode: element.SabrePropCode,
              SabreRateAccessCode: this.SabreRAC,
              WorldspanChainCode: element.WorldspanChainCode,
              WorldspanPropCode: element.WorldspanPropCode,
              WorldspanRateAccessCode: this.WorldspanRAC,
              CurrencyCode: element.CurrencyFormatCode,
              CurrencyFormatID: element.CurrencyFormatID,
              Season1ExpectedPrice: element.Season1ExpectedPrice,
              Season1StartDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season1StartDate),
              Season1EndDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season1EndDate),
              Season2ExpectedPrice: element.Season2ExpectedPrice,
              Season2StartDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season2StartDate),
              Season2EndDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season2EndDate),
              Season3ExpectedPrice: element.Season3ExpectedPrice,
              Season3StartDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season3StartDate),
              Season3EndDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season3EndDate),
              Season4ExpectedPrice: element.Season4ExpectedPrice,
              Season4StartDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season4StartDate),
              Season4EndDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season4EndDate),
              Season5ExpectedPrice: element.Season5ExpectedPrice,
              Season5StartDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season5StartDate),
              Season5EndDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season5EndDate),
              Season6ExpectedPrice: element.Season6ExpectedPrice,
              Season6StartDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season6StartDate),
              Season6EndDate: RIAHelper.BuildWsDateFromDateForRateAvail(element.Season6EndDate),
              OverallStatus: undefined,
              HotelCRSCode: element.HotelCRSCode,
              Season1Dynamic: element.Season1Dynamic,
              Season2Dynamic: element.Season2Dynamic,
              Season3Dynamic: element.Season3Dynamic,
              Season4Dynamic: element.Season4Dynamic,
              Season5Dynamic: element.Season5Dynamic,
              Season6Dynamic: element.Season6Dynamic,
              Season1Ceiling: element.Season1Ceiling,
              Season2Ceiling: element.Season2Ceiling,
              Season3Ceiling: element.Season3Ceiling,
              Season4Ceiling: element.Season4Ceiling,
              Season5Ceiling: element.Season5Ceiling,
              Season6Ceiling: element.Season6Ceiling,


            })

          }
        });

        if (this.radioRunAuditWhen == "RunNow") {
          this.auditDateTime = this.now().toJsDate();
        }
        else if (this.radioRunAuditWhen == "RunLater") {

          var dd=new Date(this.auditDate).getDate();
          var mm=new Date(this.auditDate).getMonth();
          var yy=new Date(this.auditDate).getFullYear();
          var hh=new Date(this.auditTime).getHours();
          var ms=new Date(this.auditTime).getMinutes();
          var newdate=new Date(yy, mm, dd, hh, ms);
          this.auditDateTime=newdate;

        }

        if (this.AuditAvl_Audit.PropSelected.length <=0) {

          this.confirmDialog.confirm("Please select at least one property","","Validation Error");
          window.scrollTo(0, 0);
        }
        else {

          if (this.AuditName == "" || this.RACFilters == "") {
            this.confirmDialog.confirm("Please fill out the required fields","","Validation Error");
            window.scrollTo(0, 0);
          }
          else {
            this.isBusy = true;
            this.AuditAvl_Audit.AuditSchedule=[{
              AuditID: "00000000-0000-0000-0000-000000000000",
              AuditScheduleID: "00000000-0000-0000-0000-000000000000",
              Name: this.AuditName,
              ProcessAuditWhen: this.auditDateTime,
              AuditNotificationName:"",
              AuditNotificationID:"",
              SendNotifications:this.buildNotification,
              AuditContactEmailAddress: this.AuditContactEmailAddress,
            }];
            let AuditSchedule = this.AuditAvl_Audit.AuditSchedule[0];
            if (this.buildNotification) {
              AuditSchedule.AuditNotificationID=  this.notificationSelection;
              AuditSchedule.AuditNotificationName = this._notificationTemplateList.find( (v)=> v.id == this.notificationSelection).name;
            }
            this.CreateAuditAvl(event);
          }
        }
      }
    }
  }
  CreateAuditAvl(event:any){
    this.rvService.CreateAuditAvl(this.AuditAvl_Audit)
    .subscribe(data => {
      this.isBusy= false;
      if(data.success){

        this.confirmDialog.confirm("Created Audit " + data.message,"","Audit Created Successfully")
          .subscribe(ok =>{
              event.okToProceed = true;
              this.okayToExit = true;
              this.router.navigate(['../../rateAvailability/monitor'], { relativeTo: this.route });
          },(err)=>{console.log(err);});
      }
      else{
        this.isBusy = false;
        this.confirmDialog.confirm("Audit was not created, " + data.message,"","Validation Error");
      }
    },(err)=>{console.log(err);
      this.isBusy = false});

  }
  updateScreen(dataItem) {
    this.auditID = dataItem.AuditID;
    this.RACFilters = dataItem.RACFilters;
    this.SabrePCC = dataItem.SabrePCC;
    this.AuditAmadeus = dataItem.AuditAmadeus;
    this.AuditApollo = dataItem.AuditApollo;
    this.AuditGalileo = dataItem.AuditGalileo;
    this.AuditSabre = dataItem.AuditSabre;
    this.AuditWorldspan = dataItem.AuditWorldspan;
    this.AuditName = dataItem.CustomerAccountID;
    let typeMap:any[]=[{code:"C", index:0},{code:"N", index:1},{code:"X", index:2}];
    let actType:string = "C";
    actType = dataItem.AccountType?dataItem.AccountType:dataItem.RateAccessType;
    this.RACTypeSelection =  this.RACTypeOptions[ typeMap.find(v => v.code ==actType).index ];
 }
  public selectionChange(event: SelectionEvent) {
    this.isSelected=true;
    let dataItem = event.selectedRows[0].dataItem;
    this.updateScreen(dataItem);
  }

  updateAllowedDateRange() {
    this.updateDateRangeMinMax();
    this.calendarController.setDateRange(
      this.datePickerStartDate,
      this.datePickerEndDate
    );
  }
  onRangeStartDateChange(value) {
    if (value >= this.minStartRange && value <= this.maxStartRange) {
      this.datePickerStartDate = value;
      this.updateAllowedDateRange();
    } else {
      this.datePickerStartDate = new Date(this.datePickerStartDate);
    }
  }

  onRangeEndDateChange(value) {
    if (value >= this.minEndRange && value <= this.maxEndRange) {
      this.datePickerEndDate = value;
      this.updateAllowedDateRange();
    } else {
      this.datePickerEndDate = new Date(this.datePickerEndDate);
    }
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.sorted = "";
    this.sorted = (state.sort.find(e => e.dir === 'asc' || e.dir == 'desc') || { 'field': '' }).field;

    this.rvService.getRateAuditDataForImport(state).
      subscribe(data => { this.view = data; if (data.total == undefined) { this.norecords = false; } else { this.norecords = true; } });;


  }
  public dataStateChangeProperty(stateProperty: DataStateChangeEvent): void {
    this.stateProperty = stateProperty;
    this.sortedProperty = "";
    this.sortedProperty = (stateProperty.sort.find(e => e.dir === 'asc' || e.dir == 'desc') || { 'field': '' }).field;

    this.viewProperty = this.rvService.BuildGridDataResult(this.auditStd_StandardAuditProperties, this.stateProperty);
  }

  public convertDateTomdyyyyFormat(date: Date) {
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
  }


  onDayClick(event) {
    var dayOfWeek;
    if (event == "Monday") { dayOfWeek = 1 }
    else if (event == "Tuesday") { dayOfWeek = 2 }
    else if (event == "Wednesday") { dayOfWeek = 3 }
    else if (event == "Thursday") { dayOfWeek = 4 }
    else if (event == "Friday") { dayOfWeek = 5 }
    else if (event == "Saturday") { dayOfWeek = 6 }
    else if (event == "Sunday") { dayOfWeek = 0 }

    this.calendarController.onButtonSelectDateRange(dayOfWeek);
  }

}
